import Request from "../request/request"
import Utils from "../utils/utils"

export default class Href {

    private static config: obj

    public static get(): Promise<obj> {
        return new Promise((resolve) => {
            if (this.config) {
                resolve(this.config)
            } else {
                this.__get()
                    .then(resolve)
            }
        })
    }

    public static getPage(name: string): Promise<obj> {
        return new Promise((resolve) => {
            this.get().then(res => {
                resolve(Utils.find<obj>(res.pages, c => c.name === name).data)
            })
        })
    }

    private static __get(): Promise<obj> {
        return new Promise((resolve) => {
            Request.get<obj>("ADMIN://Config/HrefConfig/Get").then(res => {
                Href.config = res
                resolve(res)
            })
        })
    }
}